exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-select .file-select-input[data-v-dd404164]{display:none}", ""]);

// exports
